const TimeItemAddButtonBox = ({ onClick }) => {
    return (
        <div className="form-box w-md">
            <button type="button" className="btn item-add" onClick={(e) => onClick(e)}>
                시간추가
            </button>
        </div>
    );
};

export default TimeItemAddButtonBox;
